<template>
  <div class="video-page-wrapper">
    <img style="height: 73vh" src="@/assets/pages/door-lock.jpeg" alt="img" />
    <PageTabs>
      <template v-slot:first>
        <div>
          <div class="video-page-texts video-page-texts-no-offset">
            <div>
              <h3>{{ $t("pages.door-locks.subtitle1") }}</h3>
              <p>{{ $t("pages.door-locks.text1") }}</p>
            </div>
          </div>
          <ProductsRow :products="products"></ProductsRow>
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands"></VoiceCommands>
      </template>
    </PageTabs>
  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
import ProductsRow from "../components/ProductsRow";
export default {
  name: "DoorLocks",
  components: { ProductsRow, VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.door-locks.commands"),
      products: [
        { img: "locks/lock-level.png", text: "Level", price: "210" },
        { img: "locks/lock-nuki.png", text: "Nuki", price: "199" },
        { img: "locks/lock-yale.png", text: "Yale", price: "167" },
        { img: "locks/lock-august.png", text: "August", price: "167" }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.img-music {
  width: 100%;
  max-width: 200px;
}
</style>
